import { Link } from "react-router-dom"
import style from "./navbar.module.css"
import logo from "../images/logo.png"

function Navbar() {
  return (
    <nav className={style.container}>
        <Link to={"/home"}>
            <img src={logo} className={style.logo} alt="Logo of page"/>
            
        </Link>
        <ul className={style.links}>
            <li><Link to={"/home"}>Home</Link></li>
            <li><Link to={"/create"}>Create Videogame</Link></li>
            <li><Link to={"/about"}>About me</Link></li>
        </ul>
    </nav>
  )
}

export default Navbar